import {
  TRIBUNAL_REVIEW_CREATE_REQUESTED,
  TRIBUNAL_REVIEW_CREATE_FAILED,
  TRIBUNAL_REVIEW_CREATE_SUCCEEDED,
  TRIBUNAL_REVIEW_DELETE_REQUESTED,
  TRIBUNAL_REVIEW_DELETE_FAILED,
  TRIBUNAL_REVIEW_DELETE_SUCCEEDED,
  TRIBUNAL_REVIEW_GET_ALL_REQUESTED,
  TRIBUNAL_REVIEW_GET_ALL_FAILED,
  TRIBUNAL_REVIEW_GET_ALL_SUCCEEDED,
  TRIBUNAL_REVIEW_GET_REQUESTED,
  TRIBUNAL_REVIEW_GET_FAILED,
  TRIBUNAL_REVIEW_GET_SUCCEEDED,
  TRIBUNAL_REVIEW_UPDATE_REQUESTED,
  TRIBUNAL_REVIEW_UPDATE_FAILED,
  TRIBUNAL_REVIEW_UPDATE_SUCCEEDED,
  CLEAR_ERROR,
} from "../actions";

const defaultError = {
  tribunalReviewCreateError: false,
  tribunalReviewCreateFetching: false,
  tribunalReviewCreateSuccess: false,

  tribunalReviewDeleteError: false,
  tribunalReviewDeleteFetching: false,
  tribunalReviewDeleteSuccess: false,

  tribunalReviewUpdateError: false,
  tribunalReviewUpdateFetching: false,
  tribunalReviewUpdateSuccess: false,

  tribunalReviewGetError: false,
  tribunalReviewGetFetching: false,
  tribunalReviewGetSuccess: false,

  tribunalReviewGetAllError: false,
  tribunalReviewGetAllSuccess: false,
  errorMsg: "",
};

const defaultState = {
  tribunalReviews: [],
  tribunalReviewDetail: {},
  tribunalReviewGetAllFetching: false,
  ...defaultError,
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        ...defaultError,
      };
    case TRIBUNAL_REVIEW_CREATE_REQUESTED:
      return {
        ...state,
        tribunalReviewCreateFetching: true,
        tribunalReviewCreateError: false,
        tribunalReviewCreateSuccess: false,
      };
    case TRIBUNAL_REVIEW_CREATE_FAILED:
      return {
        ...state,
        tribunalReviewCreateFetching: false,
        tribunalReviewCreateError: true,
        tribunalReviewCreateSuccess: false,
        errorMsg: action.payload,
      };
    case TRIBUNAL_REVIEW_CREATE_SUCCEEDED:
      return {
        ...state,
        tribunalReviewDetail: action.payload,
        tribunalReviewCreateFetching: false,
        tribunalReviewCreateError: false,
        tribunalReviewCreateSuccess: true,
      };

    case TRIBUNAL_REVIEW_DELETE_REQUESTED:
      return {
        ...state,
        tribunalReviewDeleteFetching: true,
        tribunalReviewDeleteError: false,
        tribunalReviewDeleteSuccess: false,
      };
    case TRIBUNAL_REVIEW_DELETE_FAILED:
      return {
        ...state,
        tribunalReviewDeleteFetching: false,
        tribunalReviewDeleteError: true,
        tribunalReviewDeleteSuccess: false,
        errorMsg: action.payload,
      };
    case TRIBUNAL_REVIEW_DELETE_SUCCEEDED:
      return {
        ...state,
        tribunalReviewDeleteFetching: false,
        tribunalReviewDeleteError: false,
        tribunalReviewDeleteSuccess: true,
      };

    case TRIBUNAL_REVIEW_UPDATE_REQUESTED:
      return {
        ...state,
        tribunalReviewUpdateFetching: true,
        tribunalReviewUpdateError: false,
        tribunalReviewUpdateSuccess: false,
      };
    case TRIBUNAL_REVIEW_UPDATE_FAILED:
      return {
        ...state,
        tribunalReviewUpdateFetching: false,
        tribunalReviewUpdateError: true,
        tribunalReviewUpdateSuccess: false,
        errorMsg: action.payload,
      };
    case TRIBUNAL_REVIEW_UPDATE_SUCCEEDED:
      return {
        ...state,
        tribunalReviewDetail: action.payload,
        tribunalReviewUpdateFetching: false,
        tribunalReviewUpdateError: false,
        tribunalReviewUpdateSuccess: true,
      };

    case TRIBUNAL_REVIEW_GET_REQUESTED:
      return {
        ...state,
        tribunalReviewGetFetching: true,
        tribunalReviewGetError: false,
      };
    case TRIBUNAL_REVIEW_GET_FAILED:
      return {
        ...state,
        tribunalReviewGetFetching: false,
        tribunalReviewGetError: true,
      };
    case TRIBUNAL_REVIEW_GET_SUCCEEDED:
      return {
        ...state,
        tribunalReviewDetail: action.payload,
        tribunalReviewGetFetching: false,
        tribunalReviewGetError: false,
      };

    case TRIBUNAL_REVIEW_GET_ALL_REQUESTED:
      return {
        ...state,
        tribunalReviewGetAllFetching: true,
        tribunalReviewGetAllError: false,
        tribunalReviewGetAllSuccess: false,
      };
    case TRIBUNAL_REVIEW_GET_ALL_FAILED:
      return {
        ...state,
        tribunalReviewGetAllFetching: false,
        tribunalReviewGetAllError: true,
        tribunalReviewGetAllSuccess: false,
      };
    case TRIBUNAL_REVIEW_GET_ALL_SUCCEEDED:
      return {
        ...state,
        tribunalReviews: action.payload,
        tribunalReviewGetAllFetching: false,
        tribunalReviewGetAllError: false,
        tribunalReviewGetAllSuccess: true,
      };
    default:
      return state;
  }
}
